import { render, staticRenderFns } from "./VideoIndexContainer.vue?vue&type=template&id=46f27131&"
import script from "./VideoIndexContainer.vue?vue&type=script&lang=js&"
export * from "./VideoIndexContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports